import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { remBaseFontSize } from '@/utils/resize.js'
import { useUserInfoStore } from '@/store/userInfo'
import { ref } from 'vue'
import * as Auth from '../service/auth'
import { LoginStatus } from '@/store/userInfo'
// 定义 code 变量
const code = ref('')
const state = ref('')

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const userInfoStore = useUserInfoStore()
  const isInfoReady = userInfoStore.isInfoReady
  if (isInfoReady && to.name === 'Login') {
    next({ name: 'Home' })
  } else {
    next()
  }
  const html = document.documentElement
  if (to.name === 'batchNovels' || to.name === 'batchShortPlay') {
    // 在 batchNovels 路由下动态计算 htmlFontSize
    const clientWidth = html.clientWidth
    if (clientWidth) {
      const oWidth = document.body.clientWidth
      html.style.fontSize = `${(oWidth / 1000) * remBaseFontSize()}px`
    }
  } else {
    // 其他路由下设置默认字体大小为 16px
    html.style.fontSize = '16px'
  }
  const urlParams = new URLSearchParams(window.location.search)
  const codeParam = urlParams.get('code')
  const stateParam = urlParams.get('state')
  // 重定向地址的参数,后面会用到
  const storedCode = localStorage.getItem('feishuCode')
  const storedState = localStorage.getItem('feishuState')
  const storedData = localStorage.getItem('userInfoStore')
  // 获取当前主机名
  const hostname = window.location.hostname
  if (codeParam && userInfoStore.status == 'NEED_TO_LOGIN') {
    code.value = codeParam
    state.value = stateParam
    Auth.login(code.value)
      .then(({ data: userInfo }) => {
        userInfoStore.userInfo = userInfo
        userInfoStore.status = LoginStatus.INFO_READY
        const stateToSave = JSON.stringify({
          userInfo: userInfo,
          status: LoginStatus.INFO_READY
        })
        localStorage.setItem('userInfoStore', stateToSave)
      })
      .catch(function (e) {
        console.error(e)
      })
  } else if (
    userInfoStore.status === 'INFO_READY' &&
    hostname !== 'localhost' &&
    hostname !== 'scriptv2-dev.qfei.cn' &&
    !window.h5sdk
  ) {
    // 检验是否登录失效
    try {
      const response = await Auth.userInfo()
      const latestUserInfo = response.data.UserInfo
      // 比较关键字段
      const isUserInfoChanged = ['name', 'open_id', 'en_name'].some(
        (key) => userInfoStore.userInfo[key] !== latestUserInfo[key]
      )
      if (isUserInfoChanged) {
        // 用户信息不一致，重置状态并重定向到登录页
        userInfoStore.status = LoginStatus.NEED_TO_LOGIN
        const stateToSave = JSON.stringify({
          status: LoginStatus.NEED_TO_LOGIN
        })
        localStorage.setItem('userInfoStore', stateToSave)
        if (to.name !== 'Login') {
          next({ name: 'Login' })
          return
        }
      }
    } catch (error) {
      // console.error('验证用户信息失败:', error);
    }
  }
  //   next()
})

// 监控路由变化，接入友盟H5-SDK
router.afterEach((to, from) => {
  const userInfoStore = useUserInfoStore()
  const { aplus_queue } = window
  aplus_queue.push({
    action: 'aplus.sendPV',
    arguments: [
      {
        is_auto: false
      },
      {
        from: from.path,
        to: to.path,
        user_id: userInfoStore.userInfo?.user_id ?? '',
        name: userInfoStore.userInfo?.name ?? ''
      }
    ]
  })
})

export function setupRouter(app) {
  app.use(router)
}

export default router
